import * as React from "react";
import { MenuItem, MenuSeparator } from "react-ui";
import ReactDOM from "react-dom";

import { ActionProps } from "../Common/ActionProps";
import { useActionClickHandler } from "../Common/handleActionClick";
import { TestPageObjectHandle } from "../../Services/TestPageObjects/TestPageObjectHandle";
import { emptyRef } from "../../TypingUtils";
import { toHtmlElementOrNull } from "../../Commons/DOM/DomHelpers";

export function DropdownButtonAction(props: ActionProps): JSX.Element {
    const buttonRef = React.useRef(emptyRef);
    const handleOnClick = useActionClickHandler(props);

    const pageObjectId = React.useMemo(
        () =>
            props["data-tid"]
                ? `${props.bindingPath?.toLegacyPath()}/${props["data-tid"]}`
                : `${props.bindingPath?.toLegacyPath()}`,
        [props["data-tid"], props.bindingPath?.toLegacyPath()]
    );

    const testPageObject = React.useMemo(
        () => ({
            getType: () => "DropdownButtonAction",
            click: () => {
                if (buttonRef.current == undefined) {
                    return false;
                }
                const element = toHtmlElementOrNull(ReactDOM.findDOMNode(buttonRef.current));
                if (element == undefined) {
                    return false;
                }
                element.click();
                return true;
            },
        }),
        [props, buttonRef.current]
    );

    if (props.menuSeparator) {
        return <MenuSeparator />;
    }

    if (!props.visible && props.visible !== undefined) {
        return <></>;
    }

    return (
        <TestPageObjectHandle id={pageObjectId} pageObject={testPageObject}>
            <MenuItem
                disabled={props.disabled}
                state={props.state}
                onMouseEnter={props.onMouseEnter}
                onMouseLeave={props.onMouseLeave}
                onClick={handleOnClick}
                ref={buttonRef}
                data-tid={props["data-tid"]}>
                {props.children}
            </MenuItem>
        </TestPageObjectHandle>
    );
}
